import React from 'react';
import ReactDOM from 'react-dom';
import { Field,formValueSelector,reduxForm } from 'redux-form';
import Select from 'react-select';
import { connect } from 'react-redux'
import LoadingSmall from '../../../components/LoadingSmall.js';
import Helpers from '../../../helpers/General.js';

const validate = values => {
    const errors = {}

    if (!values.CHAT_TEXT_SEND) {
        errors.CHAT_TEXT_SEND = 'Required'
    }

    if (!values.CHAT_TEXT_TYPE_MESSAGE) {
        errors.CHAT_TEXT_TYPE_MESSAGE = 'Required'
    }

    if (!values.CHAT_TEXT_EMAIL) {
        errors.CHAT_TEXT_EMAIL = 'Required'
    }

    if (!values.CHAT_TEXT_NAME) {
        errors.CHAT_TEXT_NAME = 'Required'
    }

    if (!values.CHAT_HEADER_MAXIMIZED_TEXT) {
        errors.CHAT_HEADER_MAXIMIZED_TEXT = 'Required'
    }

    if (!values.CHAT_TEXT_OPERATOR_REPLY_TIME) {
        errors.CHAT_TEXT_OPERATOR_REPLY_TIME = 'Required'
    }

    if (!values.CHAT_TEXT_GET_NOTIFIED) {
        errors.CHAT_TEXT_GET_NOTIFIED = 'Required'
    }

    if (!values.CHAT_TEXT_OFFLINE_MESSAGE) {
        errors.CHAT_TEXT_OFFLINE_MESSAGE = 'Required'
    }

    if (!values.CHAT_TEXT_CLOSED_MESSAGE) {
        errors.CHAT_TEXT_CLOSED_MESSAGE = 'Required'
    }

    if (!values.CHAT_TEXT_CLOSED_BTN) {
        errors.CHAT_TEXT_CLOSED_BTN = 'Required'
    }




    return errors
}

const renderField = ({ input, name,className,placeholder, title, type, meta: { touched, error } }) => (

    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <input {...input}  placeholder={placeholder} name={name} className={className} type={type}/>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

const select = ({ input, options,name,className,placeholder, title, type, meta: { touched, error } }) => (
    <div className={`form-group form-material floating ${touched && error ? 'has-danger':''}`} data-plugin="formMaterial">
        <select name={name} className="form-control" value={input.value} onChange={input.onChange}>
            {options.map((item,i) => {
                return <option key={i} value={item.value}>{item.label}</option>
            })}
        </select>
        <label className="floating-label">{title}</label>
        <small className="text-help">{touched && ((error && <span>{error}</span>))}</small>
    </div>
)

                                    

class ChatTranslation extends React.Component {


    render() {
        const { handleSubmit } = this.props;
        return (
            <form onSubmit={handleSubmit}>
                <div className="row">
                          
                                
                            <div className="row">
                                <div className="col-sm-12">
                                    <Field component={renderField} type="text" placeholder="Name" name="CHAT_TEXT_NAME"  className="form-control" title="Name" />
                                </div>
                                <div className="col-sm-12">
                                    <Field component={renderField} type="text" placeholder="E-mail" name="CHAT_TEXT_EMAIL"  className="form-control" title="E-mail" />
                                </div>
                                <div className="col-sm-12">
                                    <Field component={renderField} type="text" placeholder="Send" name="CHAT_TEXT_SEND"  className="form-control" title="Send" />
                                </div>
                                <div className="col-sm-12">
                                    <Field component={renderField} type="text" placeholder="Type a message..." name="CHAT_TEXT_TYPE_MESSAGE"  className="form-control" title="Type a message..." />
                                </div>
                                <div className="col-sm-12">
                                    <Field component={renderField} type="text" placeholder="Chat with us!" name="CHAT_HEADER_MAXIMIZED_TEXT"  className="form-control" title="Chat with us!" />
                                </div>

                                <div className="col-sm-12">
                                    <Field component={renderField} type="text" placeholder="Agent typically replies in a few hours. Don't miss their reply." name="CHAT_TEXT_OPERATOR_REPLY_TIME"  className="form-control" title="Agent typically replies in a few hours. Don't miss their reply." />
                                </div>
                                <div className="col-sm-12">
                                    <Field component={renderField} type="text" placeholder="Get notified by e-mail" name="CHAT_TEXT_GET_NOTIFIED"  className="form-control" title="Get notified by e-mail" />
                                </div>
                                <div className="col-sm-12">
                                    <Field component={renderField} type="text" placeholder="We're not around right now. Please type your e-mail below and leave your question. We'll get back to you as soon as we can." name="CHAT_TEXT_OFFLINE_MESSAGE"  className="form-control" title="We're not around right now. Please type your e-mail below and leave your question. We'll get back to you as soon as we can." />
                                </div>
                                <div className="col-sm-12">
                                    <Field component={renderField} type="text" placeholder="Thanks for chatting with us. Have a nice day." name="CHAT_TEXT_CLOSED_MESSAGE"  className="form-control" title="Thanks for chatting with us. Have a nice day." />
                                </div>
                                <div className="col-sm-12">
                                    <Field component={renderField} type="text" placeholder="Start a new conversation" name="CHAT_TEXT_CLOSED_BTN"  className="form-control" title="Start a new conversation" />
                                </div>
                            </div>


                            <div className="row m-t-20">
                                <div className="col-sm-12">
                                    {
                                        this.props.isSavingTranslation
                                        ?
                                        <LoadingSmall />
                                        :
                                        <button type="submit" className="btn btn-dark btn-block">Update</button>
                                    }
                                </div>
                            </div>
                </div>
                
            </form>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({

});


// Decorate the form component
ChatTranslation = reduxForm({
  form: 'ChatTranslation',
  validate,
})(ChatTranslation);

ChatTranslation = connect(
  state => ({
  	initialValues: {
        CHAT_TEXT_SEND: state.general.settings.CHAT_TEXT_SEND,
        CHAT_TEXT_EMAIL: state.general.settings.CHAT_TEXT_EMAIL,
        CHAT_TEXT_TYPE_MESSAGE: state.general.settings.CHAT_TEXT_TYPE_MESSAGE,
        CHAT_TEXT_NAME: state.general.settings.CHAT_TEXT_NAME,
        CHAT_HEADER_MAXIMIZED_TEXT: state.general.settings.CHAT_HEADER_MAXIMIZED_TEXT,

        CHAT_TEXT_OPERATOR_REPLY_TIME: state.general.settings.CHAT_TEXT_OPERATOR_REPLY_TIME,
        CHAT_TEXT_GET_NOTIFIED: state.general.settings.CHAT_TEXT_GET_NOTIFIED,
        CHAT_TEXT_OFFLINE_MESSAGE: state.general.settings.CHAT_TEXT_OFFLINE_MESSAGE,
        CHAT_TEXT_CLOSED_MESSAGE: state.general.settings.CHAT_TEXT_CLOSED_MESSAGE,
        CHAT_TEXT_CLOSED_BTN: state.general.settings.CHAT_TEXT_CLOSED_BTN,


      }
  })
)(ChatTranslation)

export default ChatTranslation;


// WEBPACK FOOTER //
// ./containers/settings/form/ChatTranslation.js